export type ColorSwatch = {
  variable: string;
  hex: string;
  shade: number;
};

export type ColorFamily = {
  name: string;
  prefix: string;
  swatches: ColorSwatch[];
};

export const COLOR_FAMILIES: ColorFamily[] = [
  {
    name: 'Blue',
    prefix: 'blue',
    swatches: [
      { variable: '$blue-1', hex: '#e6f7ff', shade: 1 },
      { variable: '$blue-2', hex: '#bae7ff', shade: 2 },
      { variable: '$blue-3', hex: '#9ad0ff', shade: 3 },
      { variable: '$blue-4', hex: '#80b6ff', shade: 4 },
      { variable: '$blue-5', hex: '#346aff', shade: 5 },
      { variable: '$blue-6', hex: '#0137fc', shade: 6 },
      { variable: '$blue-7', hex: '#0004c9', shade: 7 },
      { variable: '$blue-8', hex: '#000096', shade: 8 },
      { variable: '$blue-9', hex: '#00007d', shade: 9 },
      { variable: '$blue-10', hex: '#000063', shade: 10 },
    ],
  },
  {
    name: 'Gray',
    prefix: 'gray',
    swatches: [
      { variable: '$gray-1', hex: '#ffffff', shade: 1 },
      { variable: '$gray-2', hex: '#fafafa', shade: 2 },
      { variable: '$gray-3', hex: '#f5f5f5', shade: 3 },
      { variable: '$gray-4', hex: '#e8e8e8', shade: 4 },
      { variable: '$gray-5', hex: '#d9d9d9', shade: 5 },
      { variable: '$gray-6', hex: '#bfbfbf', shade: 6 },
      { variable: '$gray-7', hex: '#8c8c8c', shade: 7 },
      { variable: '$gray-8', hex: '#595959', shade: 8 },
      { variable: '$gray-9', hex: '#262626', shade: 9 },
      { variable: '$gray-10', hex: '#000000', shade: 10 },
    ],
  },
  {
    name: 'Red',
    prefix: 'red',
    swatches: [
      { variable: '$red-1', hex: '#fff1f0', shade: 1 },
      { variable: '$red-2', hex: '#ffccc7', shade: 2 },
      { variable: '$red-3', hex: '#ffa39e', shade: 3 },
      { variable: '$red-4', hex: '#ff7875', shade: 4 },
      { variable: '$red-5', hex: '#ff4d4f', shade: 5 },
      { variable: '$red-6', hex: '#f5222d', shade: 6 },
      { variable: '$red-7', hex: '#cf1322', shade: 7 },
      { variable: '$red-8', hex: '#a8071a', shade: 8 },
      { variable: '$red-9', hex: '#820014', shade: 9 },
      { variable: '$red-10', hex: '#5c0011', shade: 10 },
    ],
  },
  {
    name: 'Green',
    prefix: 'green',
    swatches: [
      { variable: '$green-1', hex: '#f6ffed', shade: 1 },
      { variable: '$green-2', hex: '#d9f7be', shade: 2 },
      { variable: '$green-3', hex: '#b7eb8f', shade: 3 },
      { variable: '$green-4', hex: '#95de64', shade: 4 },
      { variable: '$green-5', hex: '#73d13d', shade: 5 },
      { variable: '$green-6', hex: '#52c41a', shade: 6 },
      { variable: '$green-7', hex: '#389e0d', shade: 7 },
      { variable: '$green-8', hex: '#237804', shade: 8 },
      { variable: '$green-9', hex: '#135200', shade: 9 },
      { variable: '$green-10', hex: '#092b00', shade: 10 },
    ],
  },
  {
    name: 'Orange',
    prefix: 'orange',
    swatches: [
      { variable: '$orange-1', hex: '#fff7e6', shade: 1 },
      { variable: '$orange-2', hex: '#ffe7ba', shade: 2 },
      { variable: '$orange-3', hex: '#ffd591', shade: 3 },
      { variable: '$orange-4', hex: '#ffc069', shade: 4 },
      { variable: '$orange-5', hex: '#ffa940', shade: 5 },
      { variable: '$orange-6', hex: '#fa8c16', shade: 6 },
      { variable: '$orange-7', hex: '#d46b08', shade: 7 },
      { variable: '$orange-8', hex: '#ad4e00', shade: 8 },
      { variable: '$orange-9', hex: '#873800', shade: 9 },
      { variable: '$orange-10', hex: '#612500', shade: 10 },
    ],
  },
  {
    name: 'Gold',
    prefix: 'gold',
    swatches: [
      { variable: '$gold-1', hex: '#fffbe6', shade: 1 },
      { variable: '$gold-2', hex: '#fff1b8', shade: 2 },
      { variable: '$gold-3', hex: '#ffe58f', shade: 3 },
      { variable: '$gold-4', hex: '#ffd666', shade: 4 },
      { variable: '$gold-5', hex: '#ffc53d', shade: 5 },
      { variable: '$gold-6', hex: '#faad14', shade: 6 },
      { variable: '$gold-7', hex: '#d48806', shade: 7 },
      { variable: '$gold-8', hex: '#ad6800', shade: 8 },
      { variable: '$gold-9', hex: '#874d00', shade: 9 },
      { variable: '$gold-10', hex: '#613400', shade: 10 },
    ],
  },
  {
    name: 'Yellow',
    prefix: 'yellow',
    swatches: [
      { variable: '$yellow-1', hex: '#feffe6', shade: 1 },
      { variable: '$yellow-2', hex: '#ffffb8', shade: 2 },
      { variable: '$yellow-3', hex: '#fffb8f', shade: 3 },
      { variable: '$yellow-4', hex: '#fff566', shade: 4 },
      { variable: '$yellow-5', hex: '#ffec3d', shade: 5 },
      { variable: '$yellow-6', hex: '#fadb14', shade: 6 },
      { variable: '$yellow-7', hex: '#d4b106', shade: 7 },
      { variable: '$yellow-8', hex: '#ad8b00', shade: 8 },
      { variable: '$yellow-9', hex: '#876800', shade: 9 },
      { variable: '$yellow-10', hex: '#614700', shade: 10 },
    ],
  },
  {
    name: 'Cyan',
    prefix: 'cyan',
    swatches: [
      { variable: '$cyan-1', hex: '#e6fffb', shade: 1 },
      { variable: '$cyan-2', hex: '#b5f5ec', shade: 2 },
      { variable: '$cyan-3', hex: '#87e8de', shade: 3 },
      { variable: '$cyan-4', hex: '#5cdbd3', shade: 4 },
      { variable: '$cyan-5', hex: '#36cfc9', shade: 5 },
      { variable: '$cyan-6', hex: '#13c2c2', shade: 6 },
      { variable: '$cyan-7', hex: '#08979c', shade: 7 },
      { variable: '$cyan-8', hex: '#006d75', shade: 8 },
      { variable: '$cyan-9', hex: '#00474f', shade: 9 },
      { variable: '$cyan-10', hex: '#002329', shade: 10 },
    ],
  },
  {
    name: 'Purple',
    prefix: 'purple',
    swatches: [
      { variable: '$purple-1', hex: '#f9f0ff', shade: 1 },
      { variable: '$purple-2', hex: '#efdbff', shade: 2 },
      { variable: '$purple-3', hex: '#d3adf7', shade: 3 },
      { variable: '$purple-4', hex: '#b37feb', shade: 4 },
      { variable: '$purple-5', hex: '#9254de', shade: 5 },
      { variable: '$purple-6', hex: '#722ed1', shade: 6 },
      { variable: '$purple-7', hex: '#531dab', shade: 7 },
      { variable: '$purple-8', hex: '#391085', shade: 8 },
      { variable: '$purple-9', hex: '#22075e', shade: 9 },
      { variable: '$purple-10', hex: '#120338', shade: 10 },
    ],
  },
  {
    name: 'Magenta',
    prefix: 'magenta',
    swatches: [
      { variable: '$magenta-1', hex: '#fff0f6', shade: 1 },
      { variable: '$magenta-2', hex: '#ffd6e7', shade: 2 },
      { variable: '$magenta-3', hex: '#ffadd2', shade: 3 },
      { variable: '$magenta-4', hex: '#ff85c0', shade: 4 },
      { variable: '$magenta-5', hex: '#f759ab', shade: 5 },
      { variable: '$magenta-6', hex: '#eb2f96', shade: 6 },
      { variable: '$magenta-7', hex: '#c41d7f', shade: 7 },
      { variable: '$magenta-8', hex: '#9e1068', shade: 8 },
      { variable: '$magenta-9', hex: '#780650', shade: 9 },
      { variable: '$magenta-10', hex: '#520339', shade: 10 },
    ],
  },
  {
    name: 'Indigo',
    prefix: 'indigo',
    swatches: [
      { variable: '$indigo-1', hex: '#eef2ff', shade: 1 },
      { variable: '$indigo-2', hex: '#e0e7ff', shade: 2 },
      { variable: '$indigo-3', hex: '#c7d2fe', shade: 3 },
      { variable: '$indigo-4', hex: '#a5b4fc', shade: 4 },
      { variable: '$indigo-5', hex: '#818cf8', shade: 5 },
      { variable: '$indigo-6', hex: '#6366f1', shade: 6 },
      { variable: '$indigo-7', hex: '#4f46e5', shade: 7 },
      { variable: '$indigo-8', hex: '#4338ca', shade: 8 },
      { variable: '$indigo-9', hex: '#3730a3', shade: 9 },
      { variable: '$indigo-10', hex: '#312e81', shade: 10 },
    ],
  },
  {
    name: 'Volcano',
    prefix: 'volcano',
    swatches: [
      { variable: '$volcano-1', hex: '#fff2e8', shade: 1 },
      { variable: '$volcano-2', hex: '#ffd8bf', shade: 2 },
      { variable: '$volcano-3', hex: '#ffbb96', shade: 3 },
      { variable: '$volcano-4', hex: '#ff9c6e', shade: 4 },
      { variable: '$volcano-5', hex: '#ff7a45', shade: 5 },
      { variable: '$volcano-6', hex: '#fa541c', shade: 6 },
      { variable: '$volcano-7', hex: '#d4380d', shade: 7 },
      { variable: '$volcano-8', hex: '#ad2102', shade: 8 },
      { variable: '$volcano-9', hex: '#871400', shade: 9 },
      { variable: '$volcano-10', hex: '#610b00', shade: 10 },
    ],
  },
  {
    name: 'Lime',
    prefix: 'lime',
    swatches: [
      { variable: '$lime-1', hex: '#fcffe6', shade: 1 },
      { variable: '$lime-2', hex: '#f4ffb8', shade: 2 },
      { variable: '$lime-3', hex: '#eaff8f', shade: 3 },
      { variable: '$lime-4', hex: '#d3f261', shade: 4 },
      { variable: '$lime-5', hex: '#bae637', shade: 5 },
      { variable: '$lime-6', hex: '#a0d911', shade: 6 },
      { variable: '$lime-7', hex: '#7cb305', shade: 7 },
      { variable: '$lime-8', hex: '#5b8c00', shade: 8 },
      { variable: '$lime-9', hex: '#3f6600', shade: 9 },
      { variable: '$lime-10', hex: '#254000', shade: 10 },
    ],
  },
  {
    name: 'Geekblue',
    prefix: 'geekblue',
    swatches: [
      { variable: '$geekblue-1', hex: '#f0f5ff', shade: 1 },
      { variable: '$geekblue-2', hex: '#d6e4ff', shade: 2 },
      { variable: '$geekblue-3', hex: '#adc6ff', shade: 3 },
      { variable: '$geekblue-4', hex: '#85a5ff', shade: 4 },
      { variable: '$geekblue-5', hex: '#597ef7', shade: 5 },
      { variable: '$geekblue-6', hex: '#2f54eb', shade: 6 },
      { variable: '$geekblue-7', hex: '#1d39c4', shade: 7 },
      { variable: '$geekblue-8', hex: '#10239e', shade: 8 },
      { variable: '$geekblue-9', hex: '#061178', shade: 9 },
      { variable: '$geekblue-10', hex: '#030852', shade: 10 },
    ],
  },
];

export type SemanticRole = {
  role: string;
  variable: string;
  hex: string;
  bgClass: string;
  txtClass: string;
};

export const SEMANTIC_ROLES: SemanticRole[] = [
  {
    role: 'Primary',
    variable: '$blue-6',
    hex: '#0137fc',
    bgClass: 'blue-6',
    txtClass: 'blue-txt-6',
  },
  {
    role: 'Primary Hover',
    variable: '$blue-5',
    hex: '#346aff',
    bgClass: 'blue-5',
    txtClass: 'blue-txt-5',
  },
  {
    role: 'Primary Light BG',
    variable: '$blue-1',
    hex: '#e6f7ff',
    bgClass: 'blue-1',
    txtClass: 'blue-txt-1',
  },
  {
    role: 'Danger',
    variable: '$red-6',
    hex: '#f5222d',
    bgClass: 'red-6',
    txtClass: 'red-txt-6',
  },
  {
    role: 'Danger Hover',
    variable: '$red-5',
    hex: '#ff4d4f',
    bgClass: 'red-5',
    txtClass: 'red-txt-5',
  },
  {
    role: 'Danger Light BG',
    variable: '$red-1',
    hex: '#fff1f0',
    bgClass: 'red-1',
    txtClass: 'red-txt-1',
  },
  {
    role: 'Success',
    variable: '$green-6',
    hex: '#52c41a',
    bgClass: 'green-6',
    txtClass: 'green-txt-6',
  },
  {
    role: 'Success Light BG',
    variable: '$green-1',
    hex: '#f6ffed',
    bgClass: 'green-1',
    txtClass: 'green-txt-1',
  },
  {
    role: 'Warning',
    variable: '$gold-6',
    hex: '#faad14',
    bgClass: 'gold-6',
    txtClass: 'gold-txt-6',
  },
  {
    role: 'Warning Light BG',
    variable: '$gold-1',
    hex: '#fffbe6',
    bgClass: 'gold-1',
    txtClass: 'gold-txt-1',
  },
  {
    role: 'Info',
    variable: '$cyan-6',
    hex: '#13c2c2',
    bgClass: 'cyan-6',
    txtClass: 'cyan-txt-6',
  },
  {
    role: 'Info Light BG',
    variable: '$cyan-1',
    hex: '#e6fffb',
    bgClass: 'cyan-1',
    txtClass: 'cyan-txt-1',
  },
];

export const TYPE_SCALE = [
  { level: 1, size: '12px', lineHeight: '20px' },
  { level: 2, size: '14px', lineHeight: '22px' },
  { level: 3, size: '16px', lineHeight: '24px' },
  { level: 4, size: '20px', lineHeight: '28px' },
  { level: 5, size: '24px', lineHeight: '32px' },
  { level: 6, size: '30px', lineHeight: '38px' },
  { level: 7, size: '38px', lineHeight: '46px' },
  { level: 8, size: '46px', lineHeight: '54px' },
  { level: 9, size: '56px', lineHeight: '64px' },
];

export const FONT_WEIGHTS = [
  { name: 'Lighter', variable: '$font-weight-lighter', value: 200, className: 'font-lighter' },
  { name: 'Light', variable: '$font-weight-light', value: 300, className: 'font-light' },
  { name: 'Normal', variable: '$font-weight-normal', value: 400, className: 'font-normal' },
  { name: 'Medium', variable: '$font-weight-medium', value: 500, className: 'font-medium' },
  { name: 'Semibold', variable: '$font-weight-semibold', value: 600, className: 'font-semibold' },
  { name: 'Bold', variable: '$font-weight-bold', value: 700, className: 'font-bold' },
  { name: 'Bolder', variable: '$font-weight-bolder', value: 900, className: 'font-bolder' },
];

export const FONT_SIZES = [
  { label: '.font-8', cssClass: 'font-8', size: '8px' },
  { label: '.font-10', cssClass: 'font-10', size: '10px' },
  { label: '.font-12', cssClass: 'font-12', size: '12px' },
  { label: '.font-14', cssClass: 'font-14', size: '14px' },
  { label: '.font-16', cssClass: 'font-16', size: '16px' },
  { label: '.font-20', cssClass: 'font-20', size: '20px' },
  { label: '.font-24', cssClass: 'font-24', size: '24px' },
];

export const SPACING_VALUES = [
  { variable: '$mr-5', value: '5px', width: 5 },
  { variable: '$mr-10', value: '10px', width: 10 },
  { variable: '$mr-12', value: '12px', width: 12 },
  { variable: '$mr-15', value: '15px', width: 15 },
  { variable: '$mr-20', value: '20px', width: 20 },
  { variable: '$mr-30', value: '30px', width: 30 },
  { variable: '$mr-32', value: '32px', width: 32 },
];

export const GAP_VALUES = [
  { label: '.gap-4', value: '4px', width: 4 },
  { label: '.gap-8', value: '8px', width: 8 },
  { label: '.gap-10', value: '10px', width: 10 },
  { label: '.gap-12', value: '12px', width: 12 },
  { label: '.gap-14', value: '14px', width: 14 },
  { label: '.gap-16', value: '16px', width: 16 },
  { label: '.gap-20', value: '20px', width: 20 },
  { label: '.gap-24', value: '24px', width: 24 },
];

export const BORDER_RADII = [
  { name: '4px (Default)', variable: '$border-radius', value: '4px' },
  { name: '8px (Cards)', variable: '$border-8', value: '8px' },
  { name: '50% (Circle)', variable: '$border-50', value: '50%' },
  { name: 'None', variable: '$border-radius-none', value: '0' },
];

export const SHADOWS = [
  { name: 'Input Focus', variable: '$input-shadow', value: '0 0 0 2px rgba(24, 144, 255, 0.5)' },
  {
    name: 'Input Error',
    variable: '$input-error-shadow',
    value: '0 0 0 2px rgba(245, 34, 45, 0.5)',
  },
  {
    name: 'Input Warning',
    variable: '$input-warning-shadow',
    value: '0 0 0 2px rgba(250, 173, 20, 0.5)',
  },
  { name: 'Popover', variable: '$popover-shadow', value: '0px 2px 8px rgba(0, 0, 0, 0.15)' },
  {
    name: 'Dropdown',
    variable: '$dropdown-custom-box-shadow',
    value: '0 0.5rem 1rem rgba(0, 0, 0, 0.175)',
  },
];

export const SIDEBAR_SECTIONS = [
  { id: 'colors', label: 'Colors' },
  { id: 'typography', label: 'Typography' },
  { id: 'spacing', label: 'Spacing' },
  { id: 'borders', label: 'Border Radius' },
  { id: 'shadows', label: 'Shadows' },
  { id: 'buttons', label: 'Buttons' },
  { id: 'avatars', label: 'Avatars' },
  { id: 'badges', label: 'Badges' },
  { id: 'text-patterns', label: 'Text Patterns' },
  { id: 'inputs', label: 'Inputs' },
  { id: 'checkboxes', label: 'Checkboxes' },
  { id: 'switches', label: 'Switches' },
  { id: 'spinners', label: 'Spinners' },
  { id: 'tags', label: 'Tags' },
  { id: 'pagination', label: 'Pagination' },
  { id: 'cards', label: 'Cards' },
  { id: 'patterns', label: 'Patterns' },
];
